import {useFormContext} from '@logistics-frontend/form/v2'
import type {Optional} from '@yandex-delivery/types'
import {get} from '@yandex-delivery/utils'
import {useMemo} from 'react'

import {useUserSettingsContext} from 'src/shared/contexts'
import {DeliveryType, SourcePointDeliveryMethod} from 'src/shared/types'

function useSourcePointSddExpressCoordinates() {
  const {watch} = useFormContext()

  return watch('sourcePoint.address.coordinates')
}

function useSourcePointNddCoordinates() {
  const {watch} = useFormContext()
  const sourcePointDeliveryMethod = watch('sourcePoint._deliveryMethod')
  const sourcePointStationCoordinates = watch('sourcePoint.station.coordinates')
  const sourcePointDropOffPointCoordinates = watch('sourcePoint.dropOffPoint.point.position')

  // Тип sourcePointStationCoordinates - any
  // eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
  const stationLongitude: Optional<number> = get('lon', sourcePointStationCoordinates)
  // Тип sourcePointStationCoordinates - any
  // eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
  const stationLatitude: Optional<number> = get('lat', sourcePointStationCoordinates)

  // Тип sourcePointStationCoordinates - any
  // eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
  const dropOffPointLongitude: Optional<number> = get('longitude', sourcePointDropOffPointCoordinates)
  // Тип sourcePointStationCoordinates - any
  // eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
  const dropOffPointLatitude: Optional<number> = get('latitude', sourcePointDropOffPointCoordinates)

  return useMemo<Optional<[number, number]>>(() => {
    switch (sourcePointDeliveryMethod) {
      case SourcePointDeliveryMethod.Station: {
        if (stationLongitude === undefined || stationLatitude === undefined) {
          return undefined
        }

        return [stationLongitude, stationLatitude]
      }
      case SourcePointDeliveryMethod.DropOffPoint: {
        if (dropOffPointLongitude === undefined || dropOffPointLatitude === undefined) {
          return undefined
        }

        return [dropOffPointLongitude, dropOffPointLatitude]
      }
      default:
        return undefined
    }
  }, [dropOffPointLatitude, dropOffPointLongitude, sourcePointDeliveryMethod, stationLatitude, stationLongitude])
}

export function useSourcePointCoordinates() {
  const {location} = useUserSettingsContext()
  const {watch} = useFormContext()
  const nddCoordinates = useSourcePointNddCoordinates()
  const sddExpressCoordinates = useSourcePointSddExpressCoordinates()

  const deliveryType = watch('deliveryType')

  return useMemo(() => {
    switch (deliveryType) {
      case DeliveryType.Express:
      case DeliveryType.SDD:
        return sddExpressCoordinates
      case DeliveryType.NDD:
        return nddCoordinates || location
    }
  }, [deliveryType, location, nddCoordinates, sddExpressCoordinates])
}
